import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import _ from 'lodash';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

export const RANGE_FEE_PICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RangeFeePickerComponent),
  multi: true
};

@Component({
  selector: 'host-range-fee-picker',
  templateUrl: 'range-fee-picker.component.html',
  styleUrls: ['range-fee-picker.component.scss'],
  providers: [ RANGE_FEE_PICKER_VALUE_ACCESSOR ]
})

export class RangeFeePickerComponent implements OnInit, ControlValueAccessor {
  // _value;
  // @Input()
  // get value () {
  //   return this._value;
  // };
  // set value (data: number[]) {
  //   // 支持设置默认值。不过目前使用地方不多，使用最多的是重置为空
  //   this._value = data;
  //   if (data) {
  //     this.start = data[0];
  //     this.end = data[1];
  //   } else {
  //     this.onReset();
  //   }
  // }
  // @Output() onSelect = new EventEmitter<number[]>();
  listOfStartOpt = [
    { label: '0', value: 0 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
    { label: '300', value: 300 },
    { label: '500', value: 500 },
    { label: '1000', value: 1000 },
    { label: '3000', value: 3000 },
    { label: '5000', value: 5000 },
    { label: '1万', value: 10000 },
    { label: '3万', value: 30000 },
    { label: '5万', value: 50000 },
    { label: '10万', value: 100000 },
    { label: '30万', value: 300000 },
    { label: '50万', value: 500000 },
    { label: '100万', value: 1000000 },
  ];
  readonly listOfEndOpt = this.listOfStartOpt.concat([
    { label: '无限', value: 99999999999 }
  ]);

  start = null;
  end = null;

  textView = '';

  dropdownVisible = false;

  _registerOnChange: (value: any) => void = (r: any) => {};
  constructor() {
  }

  ngOnInit() {
  }

  // onClickOptItem (item, type) {
  //   if (type === 'start') {
  //     this.start = item.value;
  //   } else {
  //     this.end = item.value;
  //   }
  //
  //   this.inputStartVisible = false;
  //   this.inputEndVisible = false;
  // }
  //
  // onVisibleChange (visible) {
  //   console.log('visible', visible);
  // }

  closeDropdown () {
    this.dropdownVisible = false;
  }

  onConfirm () {
    if (_.isNil(this.start) || _.isNil(this.end)) {
      return;
    }
    const start = _.chain(this.listOfStartOpt).find({ value: this.start }).get('label').value();
    const end = _.chain(this.listOfEndOpt).find({ value: this.end }).get('label').value();
    this.textView = `${start || this.start}~${end || this.end}`;
    console.log('start: ', start, ' end: ', end);

    this.closeDropdown();
    this._registerOnChange([this.start, this.end]);
  }

  onReset () {
    this.start = null;
    this.end = null;
    this.textView = '';
    this._registerOnChange(null);
    this.closeDropdown();
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(value: number[]): void {
    // 支持设置默认值。不过目前使用地方不多，使用最多的是重置为空
    // this._value = value;
    if (value) {
      this.start = value[0];
      this.end = value[1];
    } else {
      // this.start = null;
      // this.end = null;
      this.onReset();
    }
  }
}
